export default __webpack_public_path__ + "static/decorist-d63e13150c35d34f3c94ea21fa1f918f.svg";